import { all, call } from 'redux-saga/effects';

import { deleteSavedFilingPeriodFileSaga } from '@sagas/savedFilingPeriod/deleteSavedFilingPeriodFileSaga';

export const deleteSavedFilingPeriodFilesSaga = function* ({ payload }) {
  const effects = payload.map(file => call(deleteSavedFilingPeriodFileSaga, { payload: file }));

  yield all(effects);
};
